import React, { useState, useEffect } from 'react';
import { withRouter } from '../../common/utils/NavigationWrapper';
import PageContainer from '../../common/components/Page/PageContainer';
import FleetSummaryContainer from './components/FleetSummary/FleetSummaryContainer';
import { getFleetDetails, getFleetReportList } from './FleetDetails.actions';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import Loading from '../../common/components/Loading/Loading';
import Utils from '../../common/utils/Utils';
import Tile from '../../common/components/Tile/Tile';
import Constants from '../../common/constants/Constants';
import Store from '../../redux/Store';
import { showSnackbar } from '../../common/state/snackbar/Snackbar.actions';
import './FleetDetails.css';
import ReportRendererContainer from '../../common/components/ReportRenderer/ReportRendererContainer';
import { matchPath } from 'react-router-dom';
import { hasUserPermission } from '../../common/components/PermissionsCheck/PermissionsCheck';
import { useSearchParams } from 'react-router-dom';
import NotFound from '../NotFound/NotFound';

const FleetsDetails = (props) => {
  const [selectedFleet, setSelectedFleet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dropdownList, setDropdownList] = useState(null);
  const fleet_report_list = useFleetReportList();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (fleet_report_list) {
      let fleetId = props.params.id;
      getFleetDetails(fleetId)
        .then((res) => {
          setSelectedFleet(res.body);
          return fleet_report_list;
        })
        .then((fleetReportsList) => {
          let selectorLinks = _constructSelectionList(fleetReportsList);
          setDropdownList(selectorLinks);

          const match = matchPath(
            {
              path: '/fleet-details/:id/:container',
            },
            props.location.pathname
          );
          if (!match) {
            //first time loading of component, needs to redirect
            let selectionFromDropdown = selectorLinks.length > 0 ? selectorLinks[0].path : '';
            props.navigate(`/fleet-details/${fleetId}${selectionFromDropdown}`);
          }
        })
        .catch((error) => setError(error))
        .finally(() => {
          setLoading(false);
        });
    }
  }, [fleet_report_list, searchParams]);

  const _constructSelectionList = (fleetReportsList) => {
    let selectorLinks = [];

    for (var section in fleetReportsList) {
      if (fleetReportsList.hasOwnProperty(section)) {
        if (
          fleetReportsList[section].hasOwnProperty('allowedPermissions') &&
          !hasUserPermission(fleetReportsList[section].allowedPermissions)
        ) {
          continue;
        } else {
          selectorLinks.splice(fleetReportsList[section].displayOrder, 0, {
            name: fleetReportsList[section].name,
            path: fleetReportsList[section].path,
          });
        }
      }
    }

    return selectorLinks;
  };

  return (
    <PageContainer pageName="fleets-details">
      <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_FLEETDETAILS}>
        {error ? showFailMessage('Could not load fleet details.') : null}
        {loading === true || selectedFleet == null ? (
          <Loading condition={true} />
        ) : (
          <div>
            <div className="fleet-details__left">
              <FleetSummaryContainer selectedFleet={selectedFleet} dropdownList={dropdownList} />
            </div>
            <div className="fleet-details__right">
              {determineComponent(props.location.pathname, selectedFleet)}
            </div>
          </div>
        )}
      </PermissionsCheck>
    </PageContainer>
  );
};

function showFailMessage(theMessage, err) {
  let messageToShow = theMessage;
  if (err != null) {
    messageToShow +=
      err.response && err.response.body.Message
        ? err.response.body.Message
        : Constants.DEFAULT_ERROR_MESSAGE;
  }

  Store.dispatch(
    showSnackbar({
      type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
      message: messageToShow,
    })
  );
}

function determineComponent(pathName, fleet) {
  var crtPath = Utils.determineCurrentPath(pathName);

  if (crtPath && crtPath.startsWith('/fleet-reports-')) {
    var query = {
      SelectedFleet: `${fleet.fleetId}`,
      ReportName: crtPath.replace('/fleet-reports-', ''),
    };

    return <ReportRendererContainer query={query} />;
  }

  switch (crtPath) {
    default:
      return <NotFound />;
  }
}

function useFleetReportList() {
  const [fleetReports, setFleetReports] = useState(null);

  useEffect(() => {
    if (!fleetReports) {
      //TO-DO get the list from Redux, not always from the api
      getFleetReportList()
        .then((res) => setFleetReports(res.body))
        .catch((err) => console.log(err));
    }
  }, [fleetReports]);

  return fleetReports;
}

export default withRouter(FleetsDetails);
